import Component from '@glimmer/component';
import image from '/assets/images/feature-previews/challenge-voting.png';

export default class UpcomingCoursesCardComponent extends Component {
  image = image;
}
